import { render, staticRenderFns } from "./block_default.vue?vue&type=template&id=a1a75d08"
import script from "./block_default.vue?vue&type=script&lang=js"
export * from "./block_default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports